// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* A date reads as one word: \"31-03-\" at a line's end and \"2027\" on the next did not. */\n.EmphasizedMessage_date__2Kolj {\n  white-space: nowrap;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Shared/BatchFlow/EmphasizedMessage/EmphasizedMessage.module.css"],"names":[],"mappings":"AAAA,uFAAuF;AACvF;EACE,mBAAmB;AACrB","sourcesContent":["/* A date reads as one word: \"31-03-\" at a line's end and \"2027\" on the next did not. */\n.date {\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"date": "EmphasizedMessage_date__2Kolj"
};
export default ___CSS_LOADER_EXPORT___;
